export { default } from './RecommendationBand';
export type { RecommendationBandProps } from './RecommendationBand';
